import { Icon, type IconProps } from "@chakra-ui/react";
import React from "react";

export function HeartIcon(props: IconProps) {
  return (
    <Icon width="20px" height="20px" viewBox="0 0 20 20" fill="none" {...props}>
      <path
        d="M17.367 3.841a4.582 4.582 0 0 0-6.484 0L10 4.725l-.883-.884a4.584 4.584 0 0 0-6.483 6.484l.883.883L10 17.69l6.483-6.483.884-.883a4.582 4.582 0 0 0 0-6.484v0Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
}
